import { type ColumnsState, createColumnsHook } from './createColumnsHook';

export const UNALLOCATED_COLUMNS = [
  'registrationNumber',
  'professional',
  'contractType',
  'profile',
  'contractStatus',
] as const;

export type UnallocatedColumn = (typeof UNALLOCATED_COLUMNS)[number];

export const UNALLOCATED_COLUMN_LABEL_KEYS = {
  registrationNumber: 'consultas.colunas.matricula',
  professional: 'consultas.colunas.profissional',
  contractType: 'consultas.colunas.tipo',
  profile: 'consultas.colunas.perfil',
  contractStatus: 'consultas.colunas.situacao',
} as const satisfies Record<UnallocatedColumn, string>;

export const useUnallocatedColumns = createColumnsHook({
  columns: UNALLOCATED_COLUMNS,
  defaultColumns: UNALLOCATED_COLUMNS,
  storageKey: 'unallocated-table-columns',
  version: 1,
});

export type UnallocatedColumnsState = ColumnsState<UnallocatedColumn>;
